<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
        <path style="fill:#00000000;" d="M5.625 24.75V3.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path style="fill:#00000000;" d="M5.625 3.375H22.5V15.75H5.625" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M5.625 3.375h4.219v4.125H5.625Z M14.063 3.375h4.219v4.125h-4.219Z M9.844 7.5h4.219v4.125H9.844Z M18.281 7.5H22.5v4.125h-4.219Z M5.625 11.625h4.219v4.125H5.625Z M14.063 11.625h4.219v4.125h-4.219Z"
            fill="white" stroke-width="0" />
    </svg>
</template>

<script>
export default {
    name: 'RacesIcon'
};
</script>
